<template>
<div id="page-carga_adjuntos_trafico" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Cargar Adjuntos a Tráfico" class="elevation-1 px-5 py-3" >
                   
                    <v-card-text>
                        <v-card-text>
                            <v-form ref="form" lazy-validation>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <p class="text-justify" >
                                            <v-icon color="indigo" >info</v-icon>                                            
                                            <strong>El archivo ZIP debe ser nombrado de la siguiente manera: 
                                                <br/> - Para tráficos utilizar el formato: NoReferencia.zip (ej. 00002.zip)
                                                <br/>Los nombres de los archivos dentro del ZIP no deben contener acentos ni caracteres especiales 
                                                    y deben tener un tipo de documento válido al inicio (Ver <v-btn small outlined text @click="showApendice()" >Apéndice de Tipos de Documentos</v-btn>, ej. 170_Factura123.xml)</strong>
                                        </p>

                                        <v-flex xs12>
                                            <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                            <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked" >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn@click.native="modal=false; reset();" >
                                <v-icon>cancel</v-icon> Cancelar</v-btn>
                                <v-btn v-if="false" color="success" >
                                    <v-icon>done</v-icon>Guardar
                                </v-btn>
                        </v-card-actions>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>

        <!-- MODAL Apendice-25-Tipos de Documentos -->
        <v-dialog v-model="modalApendice" max-width="80%" style=" z-index: 400 !important;" >
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal" >
                        <v-icon @click.native="modalApendice = false" class="white--text" >cancel</v-icon>&nbsp;
                        <span class="subheading" >
                            <strong>Tipos de Documentos</strong>
                        </span>
                    </v-card>                    
                </v-card-title>
                <v-card-text>
                    <v-client-table ref="vuetableApendice" :data="apendice_items" :columns="columns" class="elevation-2 pa-2" >
                        <template slot="noResults" >
                            <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                        </template>                                                                        
                    </v-client-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="modalApendice = false" >
                        <v-icon>cancel</v-icon>Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</div>
</template>

<script>
import axios from "axios";
import JSZip from 'jszip'

export default {
    created: function () {
        this.cliente = this.$local_storage.get("id_cliente");
        //this.model.cliente = 52;    
    },
    data() {
        return {
            fab: false,

            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Logística",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Cargar Adjuntos Tráfico",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            modalApendice: false,
            apendice_items: [],
            columns: [
                "clave",
                "descripcion",            
            ],

            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/zip',

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {
        getCamposLayout: function () {
            axios
                .get(this.$hostname + "catalogos/templates/campos_doc/ ")
                .then(response => {
                    this.camposLayout = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los templates.",
                        footer: ""
                    });
                });
        },
        pickFile() {
            this.$refs.file_input.click()
        },

        onFilePicked(e) {
            try {
                const files = e.target.files;
                
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;
                                        
                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }

                    var nombre = this.name_file.split(".");
                    var split = [];
                    var valido = false;

                    if (nombre.length == 2){                        
                        split = nombre[0].split("-");
                        if (split.length == 1){ 
                            const patternTrafico = /^[0-9]+$/;                            
                            if (patternTrafico.test(nombre[0])){                                                                
                                valido = true;
                            }
                        } 
                    } 

                    if (valido == false){
                        this.reset();
                        this.$swal({
                            type: "warning",
                            title: "Favor de verificar",
                            text: "El archivo ZIP debe tener el nombre correcto con referencia de tráfico.",
                            footer: ""
                        });
                    } else {
                        
                        /*Se cambio para que lo suba directo a SE y ya luego lo lea en la lambda*/
                        this.uploadFile(files[0], nombre[0]);                        

                        /*var thisObj = this;
                        const fr = new FileReader()
                        fr.readAsDataURL(files[0])

                        fr.addEventListener('load', () => {
                            this.file = fr.result; // this is an image file that can be sent to server...          
                            var n = this.file.search("base64,");
                            //Para dejar solo el archivo en base 64 y quitar laparte de "application/zip; base64,"
                            
                            if (n >= 0) {
                                this.file = this.file.substring(n + 7);
                            }
                            //console.log(this.file);
                            this.submitFile(nombre[0]);
                            
                        });*/
                        
                    }                    

                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var keyFile = "bandeja_entrada/"+this.name_file;
            var thisObj = this;
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: this.type_file
            }
            axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {headers:{'Content-Type': this.type_file}})
                        .then((res) => {
                            thisObj.submitFile(referencia, keyFile);                            
                        })                            
                        .catch((error)=>{
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                footer: '',
                            });
                            console.log(error);
                        });
                        
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
        },

        submitFile(referencia, keyFile) {                                           
            let formData = {
                key: keyFile,
                filename: this.name_file,
                tipo: 'mercancia',//Por default
                referencia: this.$local_storage.get("rfc") +"-"+referencia,
                user_updated: this.$local_storage.get("email"),
                usuario: this.$local_storage.get("id_usuario"),
            };
            /*let formData = {
                key: "keystring",
                filename: "730-3658-0003766-2020.zip",
                tipo: 'mercancia',//Por default
                referencia: this.$local_storage.get("rfc") +"-730-3658-0003766-2020",
                user_updated: this.$local_storage.get("email"),
                usuario: this.$local_storage.get("id_usuario"),
            };*/

            //axios.post('http://127.0.0.1:7000/leexml/', formData)                
            axios.post(this.$hostname + 'leexml/', formData)                            
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                            footer: '',
                        });
                    }

                })
                .catch((error) => {
                    var msg = ''
                    var mostrar = true;
                    if (error.response != null) {
                        if (error.response.data.mensaje != null)
                            msg = error.response.data.mensaje[0];
                        if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine                
                            mostrar = false;
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                footer: '',
                            });
                            msg = error.response.data.message;                                
                        }
                    }
                    if (mostrar) {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el archivo",
                            footer: msg,
                        });
                        console.log(error);
                    }

                }).then(() => {                        
                    this.$root.$dialogLoader.hide();
                    this.reset();
                });

        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
        showApendice(){
            if (this.apendice_items.length <= 0){            
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');                                                
                    axios.post(this.$hostname + 'apendices/lista/', {tabla:25})
                        .then((res) => {
                            this.apendice_items = res.data;
                            this.modalApendice =true;
                        })
                        .catch((error) => {                        
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al obtener los registros del apéndice",
                                footer: "",
                            });
                            console.log(error);                    
                        }).then(() => {                        
                            this.$root.$dialogLoader.hide();                        
                        });
            } else {
                this.modalApendice =true;
            }
        },
    }
};
</script>
